import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EntityCollectionService, EntityServices } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import { combineLatest } from 'rxjs/internal/observable/combineLatest';
import { map } from 'rxjs/operators';
import { availableDeviceDataServiceConfig } from '../modules/admin/user/devices/available-devices.entity';
import { AvailableDevicesSelectors } from '../modules/admin/user/devices/state/available-devices.selector';
import { MediaDevice } from '../modules/admin/user/models/user-device.model';
import { AdminAccountService } from '../services/admin/admin-account.service';
import { PreviewEditTemplateActions } from './state/preview-edit-template.actions';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalConfirmComponent, createConfirmModalOptions } from '../core/modal/modal-confirm.component';
import { BsModalAlertComponent, createAlertModalOptions } from '../core/modal/modal-alert.component';

@Component({
    selector: 'template-media',
    templateUrl: './preview-edit-template-media.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class PreviewEditTemplateMediaComponent implements OnInit {

    @Input() selectedUserId;
    @Input() templateMedia;
    @Output() readonly isMediaChanged = new EventEmitter<boolean>();

    viewModel$: Observable<any>;
    userDevices$: Observable<any>;
    devicesSms$: Observable<Array<MediaDevice>>;
    devicesEmail$: Observable<Array<MediaDevice>>;
    devicesVoice$: Observable<Array<MediaDevice>>;
    selectedEmailDevice: any;
    selectedSmsDevice: any;
    selectedVoiceDevice: any;
    isSMSDevice = false;
    isEmailDevice = false;
    isVoiceDevice = false;
    mediaDevices: Array<any> = new Array<any>();
    updatedMediaDevices = new Array<any>();

    private availableDevicesService: EntityCollectionService<MediaDevice>;
    constructor(private availableDevicesSelectors: AvailableDevicesSelectors,
                private adminAccountService: AdminAccountService,
                private store: Store<any>,
                private entityServices: EntityServices,
                private modalService: BsModalService,
    ) {
        this.availableDevicesService =
            this.entityServices.getEntityCollectionService<MediaDevice>(availableDeviceDataServiceConfig.entityName);
        this.devicesSms$ = availableDevicesSelectors.selectSMSDevices();
        this.devicesEmail$ = availableDevicesSelectors.selectEmailDevices();
        this.devicesVoice$ = availableDevicesSelectors.selectVoiceDevices();

    }

    ngOnInit(): void {
        this.availableDevicesService.getAll();
        this.userDevices$ = this.selectedUserId !== undefined ?
            this.adminAccountService.getUserDevices(this.selectedUserId) : this.adminAccountService.getUserDevices(0);

        this.viewModel$ = combineLatest([
            this.userDevices$,
            this.devicesSms$,
            this.devicesEmail$,
            this.devicesVoice$]
        )
            .pipe(
            map(([userDevices, deviceSms, devicesEmail, devicesVoice]) => {

                const devices = new Array<any>(userDevices);
                const usersDevices: Array<any> = devices[0];

                let userEmailDevice;
                let userSmsDevice;
                let userVoiceDevice;
                let templateEmailDevice;
                let templateSmsDevice;
                let templateVoiceDevice;
                if (userDevices !== undefined) {
                    userEmailDevice = usersDevices.find(device => device.type === 'email');
                    userSmsDevice = usersDevices.find(device => device.type === 'sms');
                    userVoiceDevice = usersDevices.find(device => device.type === 'voice');
                }

                if (this.templateMedia !== undefined && this.templateMedia !== null) {
                    templateEmailDevice = this.templateMedia.find(media => media.type === 'email');
                    templateSmsDevice = this.templateMedia.find(media => media.type === 'sms');
                    templateVoiceDevice = this.templateMedia.find(media => media.type === 'voice');
                }

                this.isSMSDevice = templateSmsDevice !== undefined && templateSmsDevice.device !== undefined;
                this.isEmailDevice = templateEmailDevice !== undefined && templateEmailDevice.device !== undefined;
                this.isVoiceDevice = templateVoiceDevice !== undefined && templateVoiceDevice.device !== undefined;

                this.selectedEmailDevice = { deviceId: templateEmailDevice !== undefined && templateEmailDevice.device !== undefined ?
                    templateEmailDevice.device : userEmailDevice.deviceId} ;
                this.selectedSmsDevice = { deviceId: templateSmsDevice !== undefined && templateSmsDevice.device !== undefined ?
                    templateSmsDevice.device : userSmsDevice.deviceId };
                this.selectedVoiceDevice = { deviceId: templateVoiceDevice !== undefined && templateVoiceDevice.device !== undefined ?
                    templateVoiceDevice.device : userVoiceDevice.deviceId };

                if (this.templateMedia !== undefined && this.templateMedia !== null) {
                        this.templateMedia.forEach(device => this.mediaDevices
                            .push({enabled: device.device !== undefined, device: this.getDeviceByType(device.type), type: device.type}));
                } else {
                    usersDevices.forEach(device =>
                        this.mediaDevices.push({enabled: false, device: this.getDeviceByType(device.type), type: device.type}));
                }

                this.store.dispatch(PreviewEditTemplateActions.updateMedia({mediaDevices: this.mediaDevices}));
                this.updatedMediaDevices = [...this.mediaDevices];

                return ({
                    userDevices, deviceSms, devicesEmail, devicesVoice
                });
            })
        );
    }

    selectedDevice(value, type): void {
        let exists = false;
        const mediaDevices: any = [];
        if (type === 'voice' && this.selectedVoiceDevice.deviceId.indexOf('pnova') !== -1) {

            this.modalService
                .show(BsModalAlertComponent, createAlertModalOptions('Alert',
                    'The selected media device is not supported. Please select voice|twilio|0 instead.'));

            return;
        }
        else {
            this.updatedMediaDevices.map(media => {
                const mediaDevice: any = {...media};
                if (mediaDevice.type === type) {
                    mediaDevice.enabled = value;
                    mediaDevice.type = type;
                    mediaDevice.device = this.getDeviceByType(type);
                    exists = true;
                }
                mediaDevices.push(mediaDevice);

                return mediaDevices;
                }
            );

            if (!exists) {
                const device = this.getDeviceByType(type);
                mediaDevices.push({enabled: value, device, type});
            }

            this.store.dispatch(PreviewEditTemplateActions.updateMedia({mediaDevices}));

            this.updatedMediaDevices = [...mediaDevices];
            this.isMediaChanged.emit(true);
        }
    }

    getDeviceByType(type): any {

            if (type === 'sms') {
                return this.selectedSmsDevice.deviceId;
            }
            if (type === 'voice') {
                return this.selectedVoiceDevice.deviceId;
            }

            if (type === 'email') {
                return this.selectedEmailDevice.deviceId;
            }

    }
}
